export default "__VITE_ASSET__BQ2_UQC9__"